export const LEAD_FROM_ZAPIER = 'zapier';
export const LEAD_FROM_WARBOX = 'dpx';
export const LEAD_FROM_QUEST = 'quest';
export const LEAD_FROM_WEB = 'web';
export const LEAD_FROM_CAROKOU = 'carokou';
export const LEAD_FROM_KRAQUEN = 'kraquen';
export const LEAD_FROM_GO_VIRTUAL = 'go-virtual';
export const LEAD_FROM_DCP = 'dcp';
export const LEAD_FROM_INCADEA = 'incadea';

export const AUTOMATED_STRING = 'Automated';
export const MANUAL_STRING = 'Manual';

export const AUTOMATED_FROM_FIELDS = [
    LEAD_FROM_KRAQUEN,
    LEAD_FROM_CAROKOU,
    LEAD_FROM_ZAPIER,
    LEAD_FROM_WEB,
    LEAD_FROM_GO_VIRTUAL,
    LEAD_FROM_DCP,
    LEAD_FROM_INCADEA,
];

export const MANUAL_FROM_FIELDS = [LEAD_FROM_WARBOX, LEAD_FROM_QUEST];
